import { useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { InfoCard } from '@backstage/core-components';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { IMAGE_VALUES_FILENAME } from '../catalog/catalogInfraTypes';
import { CopyButton } from '../ui/InfraPrimitives';
import { IMAGE_VALUES_EXAMPLE } from './imageValuesExample';
import styles from './portalManifestGuide.module.css';

const PortalManifestGuide = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <InfoCard title="Image defaults (optional)" variant="gridItem">
      <Typography variant="body2" className={styles.intro}>
        Optional <strong>{IMAGE_VALUES_FILENAME}</strong> at the repo root — values
        load automatically on the next step.
      </Typography>

      <Accordion
        expanded={expanded}
        onChange={(_, isExpanded) => setExpanded(isExpanded)}
        elevation={0}
        style={{ background: 'transparent' }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2">
            {expanded ? 'Hide example' : 'Example to copy'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ paddingTop: 0 }}>
          <div style={{ width: '100%' }}>
            <div className={styles.exampleHeader}>
              <span className={styles.exampleLabel}>{IMAGE_VALUES_FILENAME}</span>
            </div>
            <div className={styles.codeWrap}>
              <div className={styles.copyAction}>
                <CopyButton text={IMAGE_VALUES_EXAMPLE} label="Copy example" />
              </div>
              <pre className={styles.codeBlock}>{IMAGE_VALUES_EXAMPLE}</pre>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </InfoCard>
  );
};

export const PortalManifestGuideFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PortalManifestGuide',
    component: PortalManifestGuide,
  }),
);
